import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { messengerService } from '../../functions/messenger';

export default function CallDebugger() {
  const { user } = useSelector((state) => ({ ...state }));
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadConversations = useCallback(async () => {
    try {
      setLoading(true);
      const data = await messengerService.getConversations(user.token);
      setConversations(data);
      console.log("📋 Loaded conversations:", data);
    } catch (error) {
      console.error("❌ Failed to load conversations:", error);
    } finally {
      setLoading(false);
    }
  }, [user.token]);

  useEffect(() => {
    loadConversations();
  }, [loadConversations]);

  const testCall = async (type) => {
    console.log("🧪 Testing call function...");
    
    if (!selectedConversation) {
      alert("Please select a conversation first!");
      return;
    }
    
    try {
      console.log("📞 Making test call:", { 
        type, 
        conversationId: selectedConversation._id,
        conversation: selectedConversation 
      });
      
      const result = await messengerService.initiateCall({
        conversationId: selectedConversation._id,
        type
      }, user.token);
      
      console.log("✅ Call test successful:", result);
      alert(`${type} call test successful!`);
    } catch (error) {
      console.error("❌ Call test failed:", error);
      alert(`${type} call test failed: ${error.message || 'Unknown error'}`);
    }
  };

  const testAPI = async () => {
    try {
      console.log("🧪 Testing API connection...");
      const response = await fetch('/api/messenger/conversations', {
        headers: {
          'Authorization': `Bearer ${user.token}`,
        },
      });
      
      if (response.ok) {
        console.log("✅ API connection successful");
        alert("API connection successful!");
      } else {
        console.error("❌ API connection failed:", response.status);
        alert(`API connection failed: ${response.status}`);
      }
    } catch (error) {
      console.error("❌ API test error:", error);
      alert(`API test error: ${error.message}`);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h1>📞 Call Function Debugger</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>User Info:</h3>
        <p>ID: {user.id}</p>
        <p>Name: {user.first_name} {user.last_name}</p>
        <p>Token: {user.token ? '✅ Available' : '❌ Missing'}</p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Conversations:</h3>
        {loading ? (
          <p>Loading conversations...</p>
        ) : conversations.length > 0 ? (
          <div>
            <select 
              value={selectedConversation?._id || ''} 
              onChange={(e) => {
                const conv = conversations.find(c => c._id === e.target.value);
                setSelectedConversation(conv);
                console.log("📋 Selected conversation:", conv);
              }}
              style={{ 
                padding: '8px', 
                marginBottom: '10px', 
                width: '100%',
                borderRadius: '4px',
                border: '1px solid #ccc'
              }}
            >
              <option value="">Select a conversation...</option>
              {conversations.map(conv => {
                const otherUser = conv.participants?.find(p => p._id !== user.id);
                const name = conv.type === 'group' ? 
                  (conv.name || 'Group Chat') : 
                  (otherUser ? `${otherUser.first_name} ${otherUser.last_name}` : 'Unknown User');
                return (
                  <option key={conv._id} value={conv._id}>
                    {name} ({conv.participants?.length || 0} participants)
                  </option>
                );
              })}
            </select>
            {selectedConversation && (
              <div style={{ 
                padding: '10px', 
                backgroundColor: '#f0f0f0', 
                borderRadius: '4px',
                fontSize: '12px'
              }}>
                <strong>Selected:</strong> {selectedConversation._id}<br/>
                <strong>Type:</strong> {selectedConversation.type}<br/>
                <strong>Participants:</strong> {selectedConversation.participants?.length || 0}
              </div>
            )}
          </div>
        ) : (
          <p>No conversations found. Create a conversation first!</p>
        )}
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>API Tests:</h3>
        <button 
          onClick={testAPI}
          style={{ 
            padding: '10px 20px', 
            margin: '5px',
            backgroundColor: '#1876f2',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Test API Connection
        </button>
        
        <button 
          onClick={loadConversations}
          style={{ 
            padding: '10px 20px', 
            margin: '5px',
            backgroundColor: '#17a2b8',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Reload Conversations
        </button>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Call Tests:</h3>
        <button 
          onClick={() => testCall('voice')}
          style={{ 
            padding: '10px 20px', 
            margin: '5px',
            backgroundColor: '#42b883',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Test Voice Call
        </button>
        
        <button 
          onClick={() => testCall('video')}
          style={{ 
            padding: '10px 20px', 
            margin: '5px',
            backgroundColor: '#e74c3c',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Test Video Call
        </button>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Instructions:</h3>
        <ol>
          <li>Open browser console (F12)</li>
          <li>Click "Test API Connection" first</li>
          <li>If API works, try the call buttons</li>
          <li>Check console for detailed logs</li>
        </ol>
      </div>

      <div style={{ 
        backgroundColor: '#f8f9fa', 
        padding: '15px', 
        borderRadius: '5px',
        fontSize: '12px',
        fontFamily: 'monospace'
      }}>

        Current URL: {window.location.href}<br/>
        User Agent: {navigator.userAgent.substring(0, 50)}...<br/>
        Local Storage: {localStorage.getItem('user') ? '✅ Has user data' : '❌ No user data'}
      </div>
    </div>
  );
} 